import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { createApp } from 'vue';
import SearchApp from './SearchApp.vue';
import { theme } from '../../front/Theme';
export class Search extends ThemeLayout {
    constructor() {
        super(...arguments);
        this.appEl = this.getElementById('app');
    }
    init() {
        this.initSearch();
    }
    async initSearch() {
        await theme().extendMeilisearchData();
        const app = createApp(SearchApp, { searchLayout: this });
        const appInstance = app.mount(this.appEl);
    }
    static buildUrl(args) {
        const url = new URL(window.location.origin);
        url.searchParams.set('s', args.query);
        if (args.indexUid) {
            url.searchParams.set(Search.UriParam.IndexUid, args.indexUid);
        }
        if (args.topicsIds) {
            url.searchParams.set(Search.UriParam.IndexUid, args.topicsIds.join(','));
        }
        if (args.staticFacets) {
            // TODO Store facets more efficiently, by factoring out indexUid & attribute ID
            url.searchParams.set(Search.UriParam.StaticFacets, args.staticFacets.join(','));
        }
        if (args.dateFrom) {
            url.searchParams.set(Search.UriParam.DateFrom, args.dateFrom);
        }
        if (args.dateTo) {
            url.searchParams.set(Search.UriParam.DateTo, args.dateTo);
        }
        return url;
    }
}
/**
 * Use namespace to declare any related types inside the layout
 */
(function (Search) {
    let UriParam;
    (function (UriParam) {
        UriParam["IndexUid"] = "i";
        UriParam["Query"] = "s";
        UriParam["Topics"] = "t";
        UriParam["StaticFacets"] = "sf";
        UriParam["DateFrom"] = "df";
        UriParam["DateTo"] = "dt";
    })(UriParam = Search.UriParam || (Search.UriParam = {}));
})(Search || (Search = {}));
